import React from 'react';
import { FadeIn } from './FadeIn';
export function FinalCTA() {
  return <section className="py-10 px-3 bg-surface text-center relative overflow-hidden" data-id="element-68">
      <div className="absolute inset-0 opacity-[0.03] bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-accent via-transparent to-transparent" data-id="element-69" />

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-70">
        <FadeIn data-id="element-71">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-accent mb-4" data-id="element-72">
            SISTEMA CLÍNICO PRO ELITE™
          </h2>

          <p className="text-lg md:text-xl text-white/80 font-medium mb-5 leading-relaxed max-w-2xl mx-auto" data-id="element-73">
            El próximo domingo podés seguir armando protocolos desde cero. O
            podés tener un sistema clínico para entrar a consulta y resolver con
            criterio, claridad y evidencia científica.
          </p>
        </FadeIn>
      </div>
    </section>;
}